import Captcha from '../Captcha';
declare var grecaptcha;

export default class GoogleRecaptcha extends Captcha {
  private scriptLoadCount = 0;

  protected async load(): Promise<void> {
    await this.loadScript();
    await new Promise((resolve) => {
      grecaptcha.ready(() => {
        let recaptchaBanner = document.querySelector('.grecaptcha-badge');
        if (recaptchaBanner) {
          (<HTMLElement>recaptchaBanner).style.visibility = 'hidden';
        }
        resolve(null);
      });
    });
  }

  protected execute(action?: string): Promise<string> {
    return grecaptcha.execute(this.getSiteKey(), {action});
  }

  protected getScriptURL(): string {
    const RECAPTCHA_NET = 'recaptcha.net';
    const GOOGLE_COM = 'google.com';
    let domain = this.options.isGlobalRecaptcha ? RECAPTCHA_NET : GOOGLE_COM;
    // If script load failures occurs continuously, fallback to using recaptcha.net instead of google.com
    if (++this.scriptLoadCount > this.MAX_RETRIES_INITIALIZE - 1) domain = RECAPTCHA_NET;
    return `https://www.${domain}/recaptcha/api.js?render=${this.getSiteKey()}`;
  }
}
